export interface VueComponentsBootstrapDependencies {
  initializeBaseUrls: () => Promise<void>;
  registerAllComponents: () => void;
  mountToastHost: () => void;
}

export async function bootstrapVueComponents({
  initializeBaseUrls,
  registerAllComponents,
  mountToastHost
}: VueComponentsBootstrapDependencies) {
  await initializeBaseUrls();
  registerAllComponents();
  mountToastHost();
}
